export default __webpack_public_path__ + "static/media/info-i.37d9d452.svg";